import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button, Form, Row, Col, ProgressBar } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { HOPDONGNGUYENTAC_API, TRUONGTHUCTAP_API, CHUONGTRINHDAOTAO_API, NGANHDAOTAO_API, FILE_MANAGER_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import axios from 'axios';
import { getToken } from '../../../../utils/helper';

const HopDongNguyenTacModal = ({ isOpen, handleClose, data, refetch }) => {
    const isEdit = !!data;
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [selectedNganhId, setSelectedNganhId] = useState('');
    const fileInputRef = useRef(null);

    const addMutation = useMutation((payload) => Post(HOPDONGNGUYENTAC_API.CREATE_ITEM, null, payload));
    const updateMutation = useMutation((payload) => Put(HOPDONGNGUYENTAC_API.UPDATE_ITEM, data?.id, payload));

    // Fetch TruongThucTap for dropdown selection
    const { data: schoolsData } = useQuery(
        ['schoolsDropdown', isOpen],
        () => Get(TRUONGTHUCTAP_API.GET_PAGING + '?PageSize=1000'),
        { enabled: isOpen }
    );

    // Fetch NganhDaoTao for dropdown selection
    const { data: sectorsData } = useQuery(
        ['sectorsDropdown', isOpen],
        () => Get(NGANHDAOTAO_API.GET_PAGING + '?PageSize=1000'),
        { enabled: isOpen }
    );

    // Fetch ChuongTrinhDaoTao filtered by NganhDaoTaoId
    const { data: majorsData } = useQuery(
        ['majorsDropdown', selectedNganhId, isOpen],
        () => Get(CHUONGTRINHDAOTAO_API.GET_PAGING + `?PageSize=1000&NganhDaoTaoId=${selectedNganhId}`),
        { enabled: isOpen }
    );

    const schools = schoolsData?.data?.$values || schoolsData?.data || schoolsData?.items?.$values || schoolsData?.items || schoolsData?.$values || schoolsData || [];
    const sectors = sectorsData?.data?.$values || sectorsData?.data || sectorsData?.items?.$values || sectorsData?.items || sectorsData?.$values || sectorsData || [];
    const majors = majorsData?.data?.$values || majorsData?.data || majorsData?.items?.$values || majorsData?.items || majorsData?.$values || majorsData || [];

    useEffect(() => {
        if (isOpen) {
            if (data) {
                const nId = data.chuongTrinhDaoTao?.nganhDaoTaoId || data.ChuongTrinhDaoTao?.NganhDaoTaoId || data.chuongTrinhDaoTao?.nganhDaoTao?.id || data.ChuongTrinhDaoTao?.NganhDaoTao?.Id || '';
                setSelectedNganhId(nId);
            } else {
                setSelectedNganhId('');
            }
        }
    }, [data, isOpen]);

    const initialValues = {
        soHopDong: data?.soHopDong || '',
        tenHopDong: data?.tenHopDong || '',
        truongThucTapId: data?.truongThucTapId || '',
        nganhId: data?.chuongTrinhDaoTao?.nganhDaoTaoId || data?.ChuongTrinhDaoTao?.NganhDaoTaoId || '',
        chuongTrinhDaoTaoId: data?.chuongTrinhDaoTaoId || '',
        ngayKy: data?.ngayKy ? moment(data.ngayKy).format('YYYY-MM-DD') : '',
        thoiHanHopDong: data?.thoiHanHopDong || '',
        ngayKetThuc: data?.ngayKetThuc ? moment(data.ngayKetThuc).format('YYYY-MM-DD') : '',
        thongTinLienHe: data?.thongTinLienHe || '',
        fileHopDongNguyenTacLink: data?.fileHopDongNguyenTacLink || '',
        ghiChu: data?.ghiChu || ''
    };

    const validationSchema = Yup.object().shape({
        soHopDong: Yup.string().required('Số hợp đồng là bắt buộc'),
        tenHopDong: Yup.string().required('Tên hợp đồng là bắt buộc'),
        truongThucTapId: Yup.string().required('Vui lòng chọn cơ sở đào tạo'),
        nganhId: Yup.string().required('Vui lòng chọn ngành'),
        chuongTrinhDaoTaoId: Yup.string().when('nganhId', {
            is: (val) => val && majors.length > 0,
            then: Yup.string().required('Vui lòng chọn chương trình đào tạo'),
            otherwise: Yup.string().nullable()
        })
    });

    const handleFileUpload = async (event, setFieldValue) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const fileSizeMB = file.size / 1024 / 1024;
        if (fileSizeMB > 20) {
            toast.error('Kích thước file quá lớn (tối đa 20MB)');
            return;
        }

        try {
            setUploading(true);
            setUploadProgress(0);
            const token = await getToken();
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(FILE_MANAGER_API.UPLOAD, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                }
            });

            const uploadedFile = response?.data?.[0];
            if (uploadedFile && uploadedFile.filePath) {
                setFieldValue('fileHopDongNguyenTacLink', uploadedFile.filePath);
                toast.success('Tải lên file hợp đồng thành công!');
            } else {
                toast.error('Tải file thất bại');
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Có lỗi xảy ra khi upload file.');
        } finally {
            setUploading(false);
            setUploadProgress(0);
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };

    const handleSubmit = (values) => {
        const payload = {
            ...values,
            thoiHanHopDong: values.thoiHanHopDong ? parseInt(values.thoiHanHopDong, 10) : null,
            ngayKy: values.ngayKy ? moment(values.ngayKy).toISOString() : null,
            ngayKetThuc: values.ngayKetThuc ? moment(values.ngayKetThuc).toISOString() : null
        };

        const mutation = isEdit ? updateMutation : addMutation;
        mutation.mutate(payload, {
            onSuccess: (res) => {
                if (res.id || res.status === 200 || res === true) {
                    toast.success(isEdit ? "Cập nhật hợp đồng thành công!" : "Thêm mới hợp đồng thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra khi lưu hợp đồng.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isEdit ? 'Chỉnh sửa hợp đồng nguyên tắc' : 'Thêm mới hợp đồng nguyên tắc'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Số hợp đồng <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="soHopDong"
                                            value={values.soHopDong}
                                            onChange={handleChange}
                                            isInvalid={touched.soHopDong && !!errors.soHopDong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.soHopDong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên hợp đồng <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenHopDong"
                                            value={values.tenHopDong}
                                            onChange={handleChange}
                                            isInvalid={touched.tenHopDong && !!errors.tenHopDong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenHopDong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Cơ sở đào tạo <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="truongThucTapId"
                                            value={values.truongThucTapId}
                                            onChange={handleChange}
                                            isInvalid={touched.truongThucTapId && !!errors.truongThucTapId}
                                        >
                                            <option value="">-- Chọn cơ sở đào tạo --</option>
                                            {schools.map(s => (
                                                <option key={s.id || s.Id} value={s.id || s.Id}>{s.tenTruong || s.TenTruong}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{errors.truongThucTapId}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                     <Form.Group className="mb-3">
                                         <Form.Label className="font-weight-bold">Ngành <span className="text-danger">*</span></Form.Label>
                                         <Form.Control
                                             as="select"
                                             name="nganhId"
                                             value={values.nganhId}
                                             onChange={(e) => {
                                                 const val = e.target.value;
                                                 setFieldValue('nganhId', val);
                                                 setSelectedNganhId(val);
                                                 setFieldValue('chuongTrinhDaoTaoId', '');
                                             }}
                                             isInvalid={touched.nganhId && !!errors.nganhId}
                                         >
                                             <option value="">-- Chọn ngành --</option>
                                             {sectors.map(s => (
                                                 <option key={s.id || s.Id} value={s.id || s.Id}>{s.tenNganh || s.TenNganh}</option>
                                             ))}
                                         </Form.Control>
                                         <Form.Control.Feedback type="invalid">{errors.nganhId}</Form.Control.Feedback>
                                     </Form.Group>
                                 </Col>
                                 {values.nganhId && majors.length > 0 && (
                                     <Col md={6}>
                                         <Form.Group className="mb-3">
                                             <Form.Label className="font-weight-bold">Chương trình đào tạo liên kết <span className="text-danger">*</span></Form.Label>
                                             <Form.Control
                                                 as="select"
                                                 name="chuongTrinhDaoTaoId"
                                                 value={values.chuongTrinhDaoTaoId}
                                                 onChange={handleChange}
                                                 isInvalid={touched.chuongTrinhDaoTaoId && !!errors.chuongTrinhDaoTaoId}
                                             >
                                                 <option value="">-- Chọn chương trình đào tạo --</option>
                                                 {majors.map(m => (
                                                     <option key={m.id || m.Id} value={m.id || m.Id}>{m.tenChuongTrinh || m.TenChuongTrinh}</option>
                                                 ))}
                                             </Form.Control>
                                             <Form.Control.Feedback type="invalid">{errors.chuongTrinhDaoTaoId}</Form.Control.Feedback>
                                         </Form.Group>
                                     </Col>
                                 )}
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ngày ký</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayKy"
                                            value={values.ngayKy}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Thời hạn (tháng)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="thoiHanHopDong"
                                            value={values.thoiHanHopDong}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ngày kết thúc</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayKetThuc"
                                            value={values.ngayKetThuc}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Thông tin liên hệ</Form.Label>
                                        <Form.Control
                                            name="thongTinLienHe"
                                            value={values.thongTinLienHe}
                                            onChange={handleChange}
                                            placeholder="Địa chỉ, số điện thoại, người phụ trách hợp đồng..."
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">File hợp đồng nguyên tắc (PDF/Scan)</Form.Label>
                                        <div className="d-flex align-items-center mb-2">
                                            <Button 
                                                variant="outline-primary" 
                                                size="sm" 
                                                onClick={() => fileInputRef.current?.click()}
                                                disabled={uploading}
                                                className="mr-3"
                                            >
                                                <i className="fas fa-upload mr-1"></i>Chọn tệp
                                            </Button>
                                            <input 
                                                type="file" 
                                                ref={fileInputRef} 
                                                hidden 
                                                accept=".pdf,.doc,.docx,.jpg,.png" 
                                                onChange={(e) => handleFileUpload(e, setFieldValue)}
                                            />
                                            {values.fileHopDongNguyenTacLink && (
                                                <div className="d-flex align-items-center">
                                                    <a 
                                                        href={`${BaseGatewayImage}${values.fileHopDongNguyenTacLink}`} 
                                                        target="_blank" 
                                                        rel="noreferrer"
                                                        className="text-primary font-weight-bold mr-3"
                                                    >
                                                        <i className="fas fa-file-pdf mr-1"></i>Xem file đã tải lên
                                                    </a>
                                                    <Button 
                                                        variant="link" 
                                                        className="text-danger p-0" 
                                                        onClick={() => setFieldValue('fileHopDongNguyenTacLink', '')}
                                                    >
                                                        Xóa
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                        {uploading && (
                                            <ProgressBar animated now={uploadProgress} label={`${uploadProgress}%`} className="mb-2" />
                                        )}
                                        <Form.Control 
                                            name="fileHopDongNguyenTacLink"
                                            value={values.fileHopDongNguyenTacLink} 
                                            readOnly 
                                            placeholder="Đường dẫn tệp tin"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="ghiChu"
                                            value={values.ghiChu}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={addMutation.isLoading || updateMutation.isLoading || uploading}>
                                {(addMutation.isLoading || updateMutation.isLoading) ? 'Đang lưu...' : 'Lưu lại'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default HopDongNguyenTacModal;
